import { createBrowserClient } from '@supabase/ssr';

export function createSupabaseBrowserClient() {
  const url =
    process.env.NEXT_PUBLIC_SUPABASE_URL_BROWSER ??
    process.env.NEXT_PUBLIC_SUPABASE_URL ??
    'http://localhost:8000';
  const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '';

  if (!key) {
    console.warn(
      '[supabase] NEXT_PUBLIC_SUPABASE_ANON_KEY no esta definida. Auth/Data fallaran.',
    );
  }

  return createBrowserClient(url, key);
}
